import { render, staticRenderFns } from "./RecipeValidation.vue?vue&type=template&id=1f7bbbe9"
import script from "./RecipeValidation.vue?vue&type=script&lang=js"
export * from "./RecipeValidation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports